import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ServiceHero = ({ 
  tag,
  title,
  description,
  bookLink,
  bookLabel = 'Book Now',
  heroImage,
  metaTitle,
  metaDescription
}) => {
  useEffect(() => {
    document.title = metaTitle || `${tag} | Canggu Podcast Studio`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', metaDescription || description || '');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = metaDescription || description || '';
      document.head.appendChild(newMeta);
    }
    return () => {
      document.title = 'Canggu Podcast Studio';
    };
  }, [metaTitle, metaDescription, tag, description]);

  return (
    <>
      {/* Breadcrumb */}
      <div className="max-w-6xl mx-auto px-6 py-4">
        <Link to="/services" className="flex items-center gap-2 text-gray-400 hover:text-[#F5A623] transition-colors text-sm">
          <ArrowLeft className="w-4 h-4" />
          Back to Services
        </Link>
      </div>

      {/* Hero Section with Background Image */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        {/* Background Image */}
        {heroImage && (
          <div className="absolute inset-0 z-0">
            <img
              src={heroImage}
              alt={tag}
              className="w-full h-full object-cover"
              decoding="async"
              fetchPriority="high"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D] via-[#0D0D0D]/90 to-[#0D0D0D]/60" />
          </div>
        )}

        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <span className="text-[#F5A623] text-sm tracking-[0.2em] font-medium mb-4 block">
              {tag}
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mb-6">
              {title}
            </h1>
            <p className="text-gray-300 text-lg mb-8 max-w-2xl">
              {description}
            </p>
            <Link
              to={bookLink}
              className="px-10 py-4 bg-[#F5A623] text-black font-semibold text-lg hover:bg-[#FFB84D] transition-colors inline-block"
              data-testid="book-now-hero"
            >
              {bookLabel}
            </Link>
          </div>
        </div>
      </section>

      {/* Mobile sticky CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-[#0D0D0D]/95 backdrop-blur-sm border-t border-[#262626] md:hidden z-40">
        <Link
          to={bookLink}
          className="block w-full py-4 bg-[#F5A623] text-black font-semibold text-lg text-center"
        >
          {bookLabel}
        </Link>
      </div>
    </>
  );
};

export default ServiceHero;
